import * as React from 'react';

import { STATE } from 'app/constants';
import { PromptProps, withPrompt } from 'app/components';
import { containerFactory, DefaultContainerProps } from 'app/infrastructure/redux';

import { ListWrapper } from './common/list-wrapper';
import { TextImport } from './common/text-import';
import { TextListRenderer } from './text/components/text-list-renderer';
import { TextListValidationErrors } from './text/components/text-list-validation-errors';
import { actionCreators } from './text/actions';
import { textConfigurationTranslation } from '../constants';
import { TextConfigurationState } from '../types-store';
import { PromptConfirmation } from 'ui';
import { blockAccessTranslation, ListType } from 'app/area/text-configuration/list/constants';
import { scrollToTop } from 'app/infrastructure/platform/routing';

export type TextConfigurationListProps = DefaultContainerProps
  & PromptProps
  & TextConfigurationState
  & typeof actionCreators;

export interface TextConfigurationListState {
  cancelChanges: boolean;
}

class TextConfigurationListComponent extends React.PureComponent<TextConfigurationListProps, TextConfigurationListState> {
  public static statePath: string = STATE.textConfiguration;

  public state: TextConfigurationListState = {
    cancelChanges: false
  };

  public componentDidMount() {
    scrollToTop();
    if (this.props.listText.metadata === undefined) {
      this.props.getMetadata();
    }
  }

  public componentWillUnmount() {
    this.props.clearList();
  }

  private cancelChanges = () => {
    this.setState({ cancelChanges: !this.state.cancelChanges });
  };

  private continueCancelChanges = () => {
    this.props.cancelChanges();
    this.cancelChanges();
  };

  private renderTextImport() {
    return this.props.listText?.showExcelImport
      ? <TextImport
        fetching={this.props.listText?.importExcelFetching}
        onClose={this.props.closeExcelImport}
        onDone={this.props.saveImport}
        clearImportValidationErrors={this.props.clearImportValidationErrors}
        translation={this.props.translation}>
        <TextListValidationErrors
          validationErrors={this.props.listText?.importValidationErrors}
          translation={this.props.translation}
        />
      </TextImport>
      : null;
  }

  public render() {

    const { listText,
      displayError,
      loadTextsList, modifyText, saveChanges,
      openExcelImport, exportToExcel,
      continue: onContinue, cancel, shouldDisplayModal,
      sharedState, translation } = this.props;

    return <ListWrapper
      displayError={displayError}
      onContinue={onContinue}
      onCancel={cancel}
      shouldDisplayModal={shouldDisplayModal}
      sharedState={sharedState}
      translation={translation}
      blockAccessTranslation={blockAccessTranslation(ListType.text, translation).text}>
      <TextListRenderer
        listState={listText}
        loadTextsList={loadTextsList}
        modifyText={modifyText}
        saveChanges={saveChanges}
        cancelChanges={this.cancelChanges}
        translation={translation}
        exportToExcel={exportToExcel}
        openExcelImport={openExcelImport}
        language={sharedState.language}
      />
      {this.renderTextImport()}
      {this.state.cancelChanges
        ? <PromptConfirmation
          title={translation.cancel_changes}
          description={translation.are_you_sure}
          continueText={translation.undo_all}
          cancelText={translation.go_back}
          onContinue={this.continueCancelChanges}
          onCancel={this.cancelChanges}
        />
        : ''}
    </ListWrapper>;
  }
}

const selectors = {
  shouldPrompt: ({ listText }: TextConfigurationListProps, _) =>
    (listText.modifiedItems || []).some(text => !text.onlyWhitespace)
};

const container = containerFactory(withPrompt(TextConfigurationListComponent), actionCreators, selectors, textConfigurationTranslation);

export { container as TextConfigurationList };
